import React from 'react';
import { Shield, Server, Mail, Flag } from 'lucide-react';

export function CGU() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-teal-600 to-teal-700 px-6 py-8 sm:px-8">
            <h1 className="text-3xl font-bold text-white">
              Conditions Générales d'Utilisation
            </h1>
            <p className="mt-2 text-teal-100">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>

          {/* Content */}
          <div className="px-6 py-8 sm:px-8 space-y-8">
            {/* Outils et Technologies */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Outils et Technologies
              </h2>
              <div className="bg-gray-50 rounded-xl p-6">
                <p className="text-gray-600 mb-4">
                  Notre plateforme utilise les technologies suivantes pour vous offrir la meilleure expérience possible :
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-700">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mr-3"></span>
                    Xano (Base de données et API)
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mr-3"></span>
                    Google Make (Automatisation)
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="w-2 h-2 bg-teal-500 rounded-full mr-3"></span>
                    ManyChat (Communication)
                  </li>
                </ul>
              </div>
            </section>

            {/* Entreprise */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Informations sur l'Entreprise
              </h2>
              <div className="bg-gray-50 rounded-xl p-6">
                <p className="text-gray-700 mb-4">
                  Emploi Paysagiste est une entité du groupe Recrutop.
                </p>
                <div className="flex items-start gap-2 text-gray-700">
                  <Shield className="h-5 w-5 text-teal-600 mt-0.5" />
                  <p>
                    <strong>Responsable de la publication :</strong><br />
                    JPSI
                  </p>
                </div>
              </div>
            </section>

            {/* Hébergement */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Hébergement
              </h2>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-start gap-3">
                  <Server className="h-5 w-5 text-teal-600 mt-1" />
                  <div>
                    <p className="text-gray-700">
                      Les données sont hébergées par OVH, un hébergeur français.
                    </p>
                    <div className="mt-2 flex items-center">
                      <Flag className="h-5 w-5 text-blue-600" />
                      <span className="ml-2 text-blue-600">Hébergement en France</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Protection des Données */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Protection des Données
              </h2>
              <div className="bg-gray-50 rounded-xl p-6 space-y-4">
                <div className="flex items-start gap-2">
                  <Mail className="h-5 w-5 text-teal-600 mt-0.5" />
                  <p className="text-gray-700">
                    Pour toute demande de suppression de vos données, veuillez contacter :<br />
                    <a 
                      href="mailto:contact@emploi-paysagiste.fr"
                      className="text-teal-600 hover:text-teal-700 font-medium"
                    >
                      contact@emploi-paysagiste.fr
                    </a>
                  </p>
                </div>
                <div className="pl-7">
                  <p className="text-gray-700">
                    <strong>Durée de conservation :</strong><br />
                    Vos données sont conservées pendant une durée de 2 ans.
                  </p>
                </div>
              </div>
            </section>

            {/* Note de bas de page */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500 text-center">
                Ces conditions générales d'utilisation peuvent être modifiées à tout moment.
                Les utilisateurs seront informés des changements via notre plateforme.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}